import React from "react";
import PageCard from "features/shared/components/card/PageCard";
import { Ets2AffidavitPlaceOfDeliveryDTO } from "../dtos/Ets2AffidavitPlaceOfDeliveryDTO";
import { useTranslation } from "react-i18next";
import Ets2AffidavitPlaceOfDeliveryHeader from "./Ets2AffidavitPlaceOfDeliveryHeader";
import Ets2AffidavitPlaceOfDelivery from "./Ets2AffidavitPlaceOfDelivery";

interface Props {
  pods: Ets2AffidavitPlaceOfDeliveryDTO[];
}

const Ets2AffidavitPlaceOfDeliveryCard = ({ pods }: Props) => {
  const t = useTranslation("ets2\\ets2").t;

  return (
    <PageCard title={t("ets2AffidavitPlaceOfDeliveryListCard.title")}>
      <Ets2AffidavitPlaceOfDeliveryHeader />
      {pods?.map((p, idx) => (
        <Ets2AffidavitPlaceOfDelivery
          key={p.placeOfDeliveryId ?? idx}
          pod={p}
        />
      ))}

      {(!pods || pods.length === 0) && (
        <div className="text-muted px-2 py-2 border-top">
          {t("ets2AffidavitPlaceOfDeliveryListCard.empty")}
        </div>
      )}
    </PageCard>
  );
};

export default Ets2AffidavitPlaceOfDeliveryCard;
